<template>
  <section class="details">
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="商品参数" name="first">
            <div class="tabs-content-table" v-html="product.desc">
            </div>
        </el-tab-pane>
        <el-tab-pane label="换新流程" name="second">
            <div class="item-content-pximg"></div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </section>
</template>

<script>
export default {
  props:["product"],
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {
    handleClick(tab, event) {
    }
  }
};
</script>

<style scoped>
.details {
  background: #fff;
  margin: 15px 0;
}
.title {
  border-bottom: solid #efefef 1px;
  padding: 10px 0;
  font-size: 20px;
  color: #f9415d;
}
.title::before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border: solid #f9415d 2px;
  margin-right: 10px;
  rotate: 10px;
  transform: rotate(45deg);
}
.title span {
  color: #ccc;
}
.detailsPic {
  background: url(../../../assets/image/detailsPic.png) center center no-repeat;
  background-size: 1254px 447px;
  width: 1254px;
  height: 447px;
  margin-top: 20px;
}
.item-content-pximg {
    width: 980px;
    height: 400px;
    background: url(../../../assets/image/mobileStepBg.png) no-repeat;
    background-size: 980px;
    margin: 30px auto 0;
}

</style>
